// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import servicesData from "../data/services.json"; // JSON dosyasını içe aktar

// const ServiceDetail = () => {
//   const { district, slug } = useParams(); // URL’den ilçe ve hizmeti al
//   const [service, setService] = useState(null);

//   useEffect(() => {
//     if (servicesData[district]) {
//       const foundService = servicesData[district].services.find(item => item.slug === slug);
//       setService(foundService || null);
//     }
//   }, [district, slug]);

//   if (!service) {
//     return <h1 className="text-red-600 text-2xl">Hizmet bulunamadı!</h1>;
//   }

//   return (
//     <div className="max-w-screen-lg mx-auto py-10 px-6">
//       <h1 className="text-3xl font-bold text-[#003132] mb-6">{service.title}</h1>
//       <p className="text-gray-700 leading-relaxed">{service.description}</p>
//     </div>
//   );
// };

// export default ServiceDetail;
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import servicesData from "../data/services.json"; // JSON dosyasını içe aktar
import LeftSidebar from "./Sidebars/LeftSidebar";
import RightSidebar from "./Sidebars/RightSidebar";

const ServiceDetail = () => {
  const { district, slug } = useParams(); // URL’den ilçe ve hizmeti al
  const [service, setService] = useState(null);

  useEffect(() => {
    if (servicesData[district]) {
      const foundService = servicesData[district].services.find(item => item.slug === slug);
      setService(foundService || null);
    }
  }, [district, slug]);

  if (!service) {
    return <h1 className="text-red-600 text-2xl text-center mt-10">Hizmetlerimiz</h1>;
  }

  return (
    <> 
     <div className="max-w-7xl mx-auto py-6 px-4 grid grid-cols-1 lg:grid-cols-4 gap-8">
       <div className="order-2 lg:order-1 w-full">
          <LeftSidebar />
        </div>
    <div className="max-w-screen-lg mx-auto py-10 px-6 order-1 lg:order-2 lg:col-span-2">
      <h1 className="text-3xl font-bold text-[#003132] mb-6">{service.title}</h1>
      <p className="text-gray-700 leading-relaxed">{service.description}</p>

      {/* Hizmet Özellikleri */}
      {service.features && (
        <div className="mt-6">
          <h2 className="text-xl font-semibold text-[#003132] mb-4">Hizmet Özellikleri</h2>
          <ul className="list-disc list-inside text-gray-700">
            {service.features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Halı Türleri */}
      {service.carpet_types && (
        <div className="mt-6">
          <h2 className="text-xl font-semibold text-[#003132] mb-4">Temizlenen Halı Türleri</h2>
          <ul className="list-disc list-inside text-gray-700">
            {service.carpet_types.map((type, index) => (
              <li key={index}>{type}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Kurutma ve Paketleme */}
      {service.drying_packaging && (
        <div className="mt-6">
          <h2 className="text-xl font-semibold text-[#003132] mb-4">Kurutma ve Paketleme</h2>
          <p className="text-gray-700">{service.drying_packaging.description}</p>
        </div>
      )}

      {/* Çevre Dostu Temizlik */}
      {service.eco_friendly && (
        <div className="mt-6">
          <h2 className="text-xl font-semibold text-[#003132] mb-4">Çevre Dostu Temizlik</h2>
          <p className="text-gray-700">{service.eco_friendly.description}</p>
        </div>
      )}

      {/* Hizmet Alanı */}
      {service.service_area && (
        <div className="mt-6">
          <h2 className="text-xl font-semibold text-[#003132] mb-4">Hizmet Verdiğimiz Bölgeler</h2>
          <ul className="list-disc list-inside text-gray-700">
            {service.service_area.main.map((area, index) => (
              <li key={index}>{area}</li>
            ))}
          </ul>
          {service.service_area.nearby && (
            <>
              <h3 className="text-lg font-semibold text-[#005950] mt-4">Yakın Bölgeler</h3>
              <ul className="list-disc list-inside text-gray-700">
                {service.service_area.nearby.map((area, index) => (
                  <li key={index}>{area}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}

      {/* İletişim Bilgileri */}
      {service.contact && (
        <div className="mt-6">
          <h2 className="text-xl font-semibold text-[#003132] mb-4">İletişim Bilgileri</h2>
          <p className="text-gray-700">📞 <strong>Telefon:</strong> {service.contact.phone}</p>
          <p className="text-gray-700">📧 <strong>E-Posta:</strong> {service.contact.email}</p>
        </div>
      )}
    </div>
    
    
     
      <div className="w-full order-3 lg:order-3">
          <RightSidebar />
        </div>

         </div>
      </>
     
  );
};

export default ServiceDetail;
